<template>
  <bvue-ui-view :scroll="true">
	  <div class="w-full">
      <button @click="$router.go(-1)" class="link flex items-center mb-8">
         <i class="material-icons">arrow_back</i>
         <label>{{ $t('volver') }}</label>
      </button>
    </div>
<div id="fondo">
<div class="frame">
	<div id="responsive1">
		<h2>About Árbola</h2>
		<p>ÁRBOLA is the first web application to sponsor trees and promote biodiversity conservation. Create a profile with your photo to donate seeds, once you plant a seed, you can select the species and place where you want to plant it. With ÁRBOLA , you can sponsor an endemic or native tree in one of the most biodiverse ecosystems on the planet.</p>
		<p>Each donation covers the installation of tree nurseries, the fencing costs, the reforestation process and the maintenance for 3 years for each sponsored tree. In addition, ÁRBOLA provides a direct link between the donor and the reforestation project. The app was launched in May 2019, so we appreciate every donation.</p>
	</div>        
	<div class="responsive2">
		<iframe id="video" width="100%" height="100%" src="https://www.youtube.com/embed/9egA4nTzgqg?&hl=en&cc_lang_pref=en&cc_load_policy=1" frameborder="0" allowfullscreen></iframe>	
	</div>
</div>

<div class="frame">
	<div id="titulo">
		<h3>About the Red Forestal Foundation</h3>
	</div>
	<div class="responsive2">
		<img src="@/assets/imgabout/imagen1.jpg" style="width: 100%">
	</div>	
	<div id="responsive3">	
		<p>The Red Forestal Foundation is a non-profit organization established in 2018 in Ecuador, our goal is to develop reforestation projects for biodiversity conservation. </p>
		<p>We area a driver in the protection of nature using the new communication technologies, to create cooperation networks and generate environmental awareness. We work together with other non-profit organizations, focused on the common goal of environmental conservation, climate change mitigation, the provision of ecosystem services and the protection of living spaces. We contribute to the development and maintenance of ecological reserves and biological connectivity corridors in Ecuador. Protecting and expanding the habitat of endangered flora and fauna species that inhabit these territories.</p>
		<div id="hidden1">
		<center>
			<img id="logo1" src="@/assets/imgabout/logoFundacion.jpg">
			<p class="dudas">If you have any questions or comments, please send us an e-mail to:<br><a href="mailto:contacto@plantavida.app">contacto@plantavida.app</a>.</p>
			<p><a href="http://redforestal.org">Visit the Red Forestal Foundation website.</a></p>
		</center>
		</div>
	</div>
</div>
<div id="hidden2">
	<center>
		<img id="logo2" src="@/assets/imgabout/logoFundacion.jpg">
		<p class="dudas">If you have any questions or comments, please send us an e-mail to:<br><a href="mailto:contacto@plantavida.app">contacto@plantavida.app</a>.</p>
		<p><a href="http://redforestal.org/en/start/" target="_blank">Visit the Red Forestal Foundation website.</a></p>
	</center>
</div>
</div>
  </bvue-ui-view>
</template>

<script>
export default {
  name: 'About_us',
  mounted() {
    this.$ga.page('/Sobre Nosotros US');
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style lang="scss">
@import '@/style/aboutresponsive.scss';

</style>


// WEBPACK FOOTER //
// src/pages/About_us.vue